import { h, Fragment } from 'preact';
import useFormStore from '../../store/useFormStore';
import AppointmentDetailsBlock from './AppointmentDetailsBlock';

/**
 * AppointmentDetailsList Component
 * Displays a list of scheduled appointments, grouped by timeslot
 */
export default function AppointmentDetailsList() {
  const scheduledAppointments = useFormStore((state) => state.scheduledAppointments);

  if (!scheduledAppointments || scheduledAppointments.length === 0) {
    return null;
  }

  // Filter out any appointments with invalid structure
  const validAppointments = scheduledAppointments.filter(appointment =>
    appointment.serviceIds && Array.isArray(appointment.serviceIds) && appointment.services && appointment.timeslot && typeof appointment.services === 'object'
  );

  if (validAppointments.length === 0) {
    return null;
  }

  return (
    <Fragment>
      {validAppointments.map((appointment, index) => {
        // Create a unique key from the service IDs array
        const appointmentKey = appointment.serviceIds
          ? appointment.serviceIds.sort().join('-')
          : `appointment-${index}`;

        return (
          <AppointmentDetailsBlock
            key={`${appointmentKey}-${index}`}
            appointmentNumber={index + 1}
            services={appointment.services}
            timeslot={appointment.timeslot}
          />
        );
      })}
    </Fragment>
  );
}
